<template>
    <div class="StoreListWrap">
        <!-- 订单页 -->
        <div class="OrderDetailWrap" v-if="detailstate">
            <div class="LineCut flexbetween">
                <div class="NewsTitle flexa"><p>服务定制</p></div>
                <div class="Return flexa" @click="Closedetail"><p>返回</p><img src="../assets/Home/return.png"></div>
            </div>
            <div class="Shop flexbetween">
                <div class="ShopName flexa">
                    <i><img :src="customdetailsdata.logo图"></i>
                    <div class="Text">
                        <p>{{  customdetailsdata.定制名称 }} </p>
                        <p><span>V {{  customdetailsdata.版本号 }}</span></p>
                        <p class="flexa"><span>{{  customdetailsdata.标签 }}</span></p>
                    </div>
                </div>
                <!--            <div class="ButtonWrap   clearfix">
                                <p style="font-size: 0.05rem;text-align: right;margin-bottom: 0.05rem">定制费用</p>
                                <p style="font-size: 0.06rem;text-align: right;color: #d5b338;font-weight: bold">￥{{ customdetailsdata.定制费用 }}/年</p>
                            </div>-->
            </div>
           <!-- <div class="ShopText">
                <p
                        v-for="(item,index) in customdetailsdata.定制说明.split('。')"
                        :key="index"
                        style="line-height: 0.22rem"
                >
                    {{ item }}
                </p>
            </div>-->
            <div class="MoreContent">
                <div class="Title1">
                    <p>定制内容</p>
                </div>
                <div class="CommList">
                    <p>{{ customdetailsdata.基础功能介绍 }}</p>
                    <p>基于上述功能的个性化系统定制</p>
                </div>
            </div>
            <div class="flexa" style="width: 90%;margin:0.05rem auto 0;height:0.2rem;border-bottom: 1px solid #fff;font-size: 0.051rem;color: #fff">选择企业</div>
            <div class="SysTemWrap">
                <ul   v-if="options.length > 0">
                    <li  class="flexa" v-for="(item,index) in options" :key="index"><input @click="saveservemoney(item.servemoney)" type="radio" name="sustem" :value="item.value" v-model="val">{{ item.label }}<span style="position: absolute;right: 0.07rem;color: #d5b338">￥{{ item.servemoney }}</span></li>
                </ul>
                <p v-else>您尚未购买任何应用产品/未注册过企业，请购买一款应用产品后注册企业再进行服务定制</p>
            </div>
            <div class="flexa" style="width: 90%;margin:0 auto;height:0.2rem;border-bottom: 1px solid #fff;font-size: 0.05rem;color: #fff">定制费用</div>
            <p style="text-align: right;font-size: 0.07rem;font-weight:bold;color: #d5b338;width: 86%;margin: 0.1rem auto">￥{{ servemoney }}</p>
            <!-- 底部汇总 -->
            <div class="Foot">
                <div class="ButtonWrap clearfix">
                    <div class="flex Yes" @click="SubmitOrder"><span>去支付</span></div>
                    <div class="flex No" @click="Closedetail"><span>取消</span></div>
                </div>
            </div>
        </div>
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>服务定制</p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../assets/Home/return.png"></div>
        </div>
        <div class="Shop flexbetween">
            <div class="ShopName flexa">
                <i><img :src="customdetailsdata.logo图"></i>
                <div class="Text">
                    <p>{{  customdetailsdata.定制名称 }} </p>
                    <p><span>V {{  customdetailsdata.版本号 }}</span></p>
                    <p class="flexa"><span>{{  customdetailsdata.标签 }}</span></p>
                </div>
            </div>
<!--            <div class="ButtonWrap   clearfix">
                <p style="font-size: 0.05rem;text-align: right;margin-bottom: 0.05rem">定制费用</p>
                <p style="font-size: 0.06rem;text-align: right;color: #d5b338;font-weight: bold">￥{{ customdetailsdata.定制费用 }}/年</p>
            </div>-->
        </div>
<!--        <div class="ShopText">
            <p
                    v-for="(item,index) in customdetailsdata.定制说明.split('。')"
                    :key="index"
                    style="line-height: 0.15rem"
            >
                {{ item }}
            </p>
        </div>-->
        <div class="MoreContent">
            <div class="Title1">
                <p>定制内容</p>
            </div>
            <div class="CommList">
                <p>{{ customdetailsdata.基础功能介绍 }}</p>
                <p>基于上述功能的个性化服务与系统化定制</p>
            </div>
        </div>
        <div class="MoreContent">
            <div class="Title1">
                <p>定制承诺</p>
            </div>
            <div class="CommList">
                <p
                        v-for="(item,index) in customdetailsdata.定制说明.split('。')"
                        :key="index"
                        style="line-height: 0.15rem"
                >
                    {{ item }}
                </p>
            </div>
        </div>
        <div class="flexa" style="width: 90%;margin:0.2rem auto 0;font-size: 0.051rem;color: #fff">选择开发者</div>
        <div class="PersonChoose flexa" @click="OpenChooseBox"><img src="../assets/add.png"><p v-if="!choosedperson.名称">请选择为您服务的开发者</p><p v-else>更换开发者</p></div>
        <div class="flex Person" v-if="choosedperson.名称">
            <div class="Icon">
                <img v-if="choosedperson.logo图" :src="choosedperson.logo图" />
                <img v-else src="../assets/defaulthead.png" />
            </div>
            <div class="Text1">
                <div class="Name">{{ choosedperson.名称 }}</div>
                <div class="Do">
                    {{ choosedperson.标签 ? choosedperson.标签.split(",")[0] : "" }}
                </div>
                <div class="Star flex">
                    <p>已选择</p>
                </div>
            </div>
        </div>
        <i style="width: 90%;background-color: #fff;height: 1px;margin: 0.05rem auto"></i>
        <p style="font-size: 0.05rem;color: #fff;opacity: 0.8;width: 90%;margin: 0 auto">定制服务费用一般为您所购买的应用产品价格×10即为定制费用，具体金额请点击定制后查看。</p>
        <div class="SubmitOrder clearfix">
   <!--         <p >总价 ￥{{ customdetailsdata.定制费用 }}/年</p>-->
            <div class="Button flex" @click="Do">定制</div>
        </div>
        <!-- 购买支付 -->
        <div class="BuyBox" v-if="buystate">
            <div class="Login">
                <div class="LoginContentWrap">
                    <div class="LoginTitle"><p><strong>Hello!</strong> 请支付...</p></div>
                    <div class="CloseBox" @click="closepay('Web_WechatOrderQuery')"><img src="../assets/Home/exit1.png"></div>
                    <!-- 支付二维码 -->
                    <div v-if="!payss">
                        <div class="CodeWrap">
                            <!--   <img :src="code">-->
                            <img src="../assets/Home/code.jpg">
                        </div>
                        <div class="flex Tip"><p>请使用微信扫描二维码支付</p></div>
                        <div class="flex ReButton" @click="Check('Web_WechatOrderQuery')">支付成功后点击这里刷新</div>
                    </div>
                    <div v-else class="flex" style="width: 100%;height:70%">
                        <i   @click="SubmitOrderData('M0042510000000000000000002')"  style="width: 0.6rem;margin: 0 0.18rem;cursor: pointer"><img style="width: 100%" src="../assets/al.png"></i>
                        <i   @click="SubmitOrderData('M0042510000000000000000001')" style="width: 0.6rem;margin: 0 0.18rem;cursor: pointer"><img style="width: 100%" src="../assets/wx.png"></i>
                    </div>
                    <div v-if="payss" class="flex ReButton" style="cursor: auto">请选择支付方式</div>
                </div>
            </div>
        </div>
        <!-- 购买支付 -->
        <div class="BuyBox" v-if="alstate">
            <div class="Login">
                <div class="LoginContentWrap" style="width: 1.8rem;height: 1.5rem">
                    <div class="LoginTitle"><p><strong>Hello!</strong> 正在支付中...</p></div>
                    <div class="CloseBox" @click="closepay('Web_AlipayTradeQuery')"><img src="../assets/Home/exit1.png"></div>
                    <!-- 支付二维码 -->
                    <div style="margin-top: 0.4rem">
                        <div class="flex Tip"><p>支付完成前请不要关闭此验证窗口</p></div>
                        <div class="flex ReButton" @click="Check('Web_AlipayTradeQuery')">支付成功后点击这里刷新</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  // eslint-disable-next-line no-unused-vars
  import { mapActions, mapGetters } from 'vuex';
  export default {
    name: 'storelist',
    inject: [
      'load'
    ],
    props: {
      flag: [String, Number],
      customdetailsdata: Object,
      choosedperson: Object,
      classid: String
    },
    data() {
      return {
        buystate: false,
        options: [],
        payss: true,
        alstate: false,
        val: '',
        detailstate: false,
        ProductData: {},
        servemoney: 0,
        orderNumber: ''
      };
    },
    computed: {
      ...mapGetters(['LoginUserInfo', 'UserInfo', 'currentSystem'])
    },
    methods: {
      Check(param) {
        this.load.show();
        this.$utils.CheckPayfor(this.orderNumber, 'GoeasyUser' + this.LoginUserInfo.userId, param).then(res => {
          console.log(res);
          this.load.hide();
          if (res.data.code === 0) {
            this.$confirm('支付成功！请前往“个人中心-注册平台”进行企业注册！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '返回',
              showClose: false,
              closeOnClickModal: false,
              type: 'success'
            }).then(() => {
              this.$router.push({
                name: 'PersonCenter'
              });
            }).catch(() => {
              this.GetOrderList('待支付', 1);
            });
          } else {
            this.$confirm('您还没有支付成功！是否继续支付？', '提示', {
              confirmButtonText: '确定',
              showClose: false,
              closeOnClickModal: false,
              type: 'error'
            }).then(() => {
              console.log('未支付');
            }).catch(() => {
              this.$confirm('"您已取消支付!请尽快到个人中心我的订单-待支付中完成支付"', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$router.push({
                  name: 'Order',
                  params: { orderstate: '待支付', index: 1 }
                });
              }).catch(() => {
                console.log('取消');
                this.buystate = false;
                this.payss = true;
                this.alstate = false;
              });
            });
          }
        }).catch(error => {
          this.load.hide();
          this.$message.error(error);
        });
      },
      saveservemoney(data) {
        this.servemoney = data;
      },
      closepay(params) {
        this.Check(params);
      },
      /* 支付前提交支付信息平台(选取支付平台最终支付调用) */
      SubmitOrderData(num) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
          data: {
            commandId: 'WBA0007010',
            buttonText: 'Verify',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            orderNumber: this.orderNumber,
            headData: {
              支付平台: num
            },
            saveGridData: 1,
            gridData: this.chooseitems
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              if (num === 'M0042510000000000000000007') {
                /* 苹果支付 */
              } else if (num === 'M0042510000000000000000002') {
                /* 支付宝 */
                this.$utils.AliPay_Web(this.orderNumber, 'GoeasyUser' + this.LoginUserInfo.userId).then(res => {
                  this.load.hide();
                  this.alstate = true;
                  this.buystate = false;
                  window.open(res.data.data, '_blank');
                  // eslint-disable-next-line no-useless-escape
                  console.log(res.data);
                }).catch(error => {
                  this.load.hide();
                  console.log(error);
                });
              } else {
                /* 微信 */
                this.$utils.WXPay_Web(this.orderNumber, 'GoeasyUser' + this.LoginUserInfo.userId).then(res => {
                  this.load.hide();
                  this.payss = false;
                  this.alstate = false;
                  console.log(res);
                }).catch(error => {
                  this.load.hide();
                  console.log(error);
                });
              }
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 生成订单 */
      CreateOrder() {
        if (this.val) {
          this.load.show();
          this.$axios({
            method: 'POST',
            url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
            data: {
              commandId: 'WBA0007009',
              buttonText: 'Verify',
              userId: 'GoeasyUser' + this.LoginUserInfo.userId,
              headData: {
                产品ID: this.customdetailsdata.产品ID,
                定制: 1,
                指定开发者: this.choosedperson.开发者ID,
                产品分类ID: this.classid,
                用户产品管理: this.val
              },
              saveGridData: 1
            }
          })
            .then(res => {
              if (res.data.code === 0) {
                console.log(res);
                this.orderNumber = res.data.data.orderNumber;
                this.buystate = true;
                this.load.hide();
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(error => {
              this.load.hide();
              this.$message.error(error);
              console.log(error);
            });
        } else {
          this.$message.error('没有选择系统/平台！');
        }
      },
      SubmitOrder() {
        this.CreateOrder();
      },
      Closedetail() {
        this.detailstate = false;
      },
      /* 服务订单列表 */
      GetServeList() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007038',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            filter: { 产品ID: this.customdetailsdata.产品ID }
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              if (res.data.data.DETAIL.length > 0) {
                this.options = [];
                for (let i in res.data.data.DETAIL) {
                  let arr = {
                    label: res.data.data.DETAIL[i].名称,
                    value: res.data.data.DETAIL[i].用户产品管理,
                    money: res.data.data.DETAIL[i].订单金额,
                    servemoney: res.data.data.DETAIL[i].服务金额
                  };
                  this.options.push(arr);
                }
                this.val = this.options[0].value;
                this.servemoney = this.options[0].servemoney;
              }
              this.detailstate = true;
            } else {
              this.$message.error(res.data.msg);
            }
            this.load.hide();
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      Do() {
        if (this.LoginUserInfo.userId) {
          if (this.choosedperson.名称) {
            this.GetServeList();
          } else {
            this.$message.error('请选择为您服务的开发者！');
          }
        } else {
          this.$emit('OpenLoginBox');
        }
      },
      OpenChooseBox() {
        this.$emit('OpenChooseBox');
      },
      Return() {
        this.$emit('CloseCustomBox');
      }
    }
  };
</script>
<style scoped lang="scss">
    @import '../../public/Value';
    .StoreListWrap{
        width: 100%;
        .BuyBox{
            width: 100%;
            height: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 4;
            .Login {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.6);
                z-index: 4;
                display: flex;
                -webkit-justify-content: center;
                -webkit-align-items: center;
                .LoginContentWrap {
                    width: 2.7rem;
                    height: 2.78rem;
                    border-radius: 0.02rem 0.1rem 0.1rem 0.1rem;
                    background: linear-gradient(to bottom right, #6666cc, #4141b3);
                    position: relative;
                    .CloseBox {
                        width: 0.15rem;
                        height: 0.15rem;
                        position: absolute;
                        cursor: pointer;
                        right: 0.05rem;
                        top: 0.05rem;
                        z-index: 4;

                        img {
                            width: 100%;
                        }
                    }
                    .NeedKnown {
                        position: absolute;
                        width: 100%;
                        bottom: 0.1rem;

                        p {
                            font-size: $SmallTextSize;
                            color: #fff;
                            text-align: center;

                            span {
                                cursor: pointer;
                                font-weight: bold;
                                margin: 0 0.02rem;
                                color: #999900;
                            }
                        }
                    }
                    .LoginTitle {
                        width: 100%;
                        margin-top: 0.05rem;

                        p {
                            font-size: $TextSize;
                            color: #fff;
                            text-indent: 0.05rem;
                        }
                    }
                }
            }
            .ReButton{
                width: 1.3rem;
                height: 0.2rem;
                background-color: #9797ff;
                color: #fff;
                font-size: $TextSize;
                margin: 0.3rem auto 0;
                border-radius: 0.2rem;
                cursor: pointer;
            }
            .CodeWrap{
                width: 1.3rem;
                height: 1.3rem;
                background-color: #fff;
                margin: 0.3rem auto 0.1rem;
                border: 0.02rem solid #fff;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .Tip{
                width: 100%;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                    margin: 0 0.03rem;
                }
                p:last-child{
                    font-size: $TextSize;
                    font-weight: bold;
                    color: #ceceff;
                }
            }
        }
        .SysTemWrap{
            width: 90%;
            margin: 0.08rem auto;
            p{
                width: 100%;
                color: #fff;
                font-size: $SmallTitleSize;
            }
            ul{
                width: 100%;
                li{
                    width: 100%;
                    margin-bottom: 0.05rem;
                    position: relative;
                    input{
                        width: 0.08rem;
                        height: 0.08rem;
                        margin-right: 0.08rem;
                        cursor: pointer;
                    }
                    font-size: $SmallTitleSize;
                    color: #fff;
                }
            }
        }
        .OrderDetailWrap{
            .Foot {
                width: 100%;
                height: 0.6rem;
                .ButtonWrap {
                    width: 90%;
                    margin: 0 auto;
                    position: relative;
                    div:last-child {
                        margin-left: 0 !important;
                    }
                    .Yes,
                    .No {
                        width: 0.8rem;
                        height: 0.25rem;
                        float: right;
                        margin-left: 0.1rem;
                        background-color: #26a2ff;
                        border-radius: 0.8rem;
                        cursor: pointer;
                        span {
                            font-size: $TextSize;
                            color: #fff;
                        }
                    }
                    .Yes {
                        background-color: #8c73b5;
                    }
                    .No {
                        background-color: #666666;
                    }
                }
                .Count {
                    width: 6.3rem;
                    height: 0.8rem;
                    margin: 0 auto;
                    p {
                        font-size: 0.32rem;
                        text-align: right;
                        font-weight: bold;
                        color: #666666;
                    }
                }
            }
            width: 50%;
            height:calc(100% - 0.8rem);
            top:0.8rem;
            left: 25%;
            position: fixed;
            z-index: 2;
            background-color: #000;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                display: none;
            }
        }
        .Person {
            width: 85%;
            height: 0.65rem;
            border-radius: 0.1rem;
            background: linear-gradient(to Right, #333333, #1b1b1b);
            margin: 0 auto 0.1rem;
            .Text1 {
                width: 2.4rem;
                margin-left: 0.1rem;
                .Time {
                    margin-bottom: 0.05rem;
                    p {
                        font-size: $AdditionTextSize;
                        opacity: 0.6;
                        color: #fff;
                    }
                }
                .Star {
                    width: 0.5rem;
                    height: 0.15rem;
                    border-radius: 0.1rem;
                    background-color: #cc9933;
                    margin-top: 0.08rem;
                    p {
                        font-size: $TextSize;
                        color: #fff;
                    }
                }
                .Active {
                    background-color: #ecb036;
                }
                .Name {
                    height: 0.1rem;
                    width: 0.7rem;
                    border-bottom: 2px solid #fff;
                    font-size: $AdditionTextSize;
                    color: #fff;
                    margin-bottom: 0.05rem;
                }
                .Do {
                    font-size: $SmallTextSize;
                    color: #fff;
                    opacity: 0.6;
                }
            }
            .Icon {
                width: 0.5rem;
                height: 0.5rem;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 0.1rem;
                }
            }
        }
        .PersonChoose{
            width: 90%;
            height: 0.35rem;
            border-radius: 0.5rem;
            border: 1px solid #fff;
            margin: 0.1rem auto;
            cursor: pointer;
            img{
                width: 0.2rem;
                margin: 0 0.1rem;
                opacity: 0.8;
            }
            p{
                font-size: $TextSize;
                color: #fff;
                opacity: 0.8;
            }
        }
        .SubmitOrder{
            width: 90%;
            margin: 0.25rem auto;
            .Button{
                width: 0.8rem;
                height: 0.25rem;
                border-radius: 0.6rem;
                background-color: #cc3333;
                float: right;
                font-size: $TextSize;
                color: #fff;
                margin-top: 0.1rem;
                cursor: pointer;
            }
            p{
                font-size: 0.06rem;
                text-align: right;
                color: #d5b338;
                font-weight: bold;
                margin-right: 0.06rem;
            }
        }
        .MoreContent{
            width: 90%;
            margin: 0 auto;
            .Title1 {
                width: 100%;
                margin: 0.12rem auto 0.08rem;
                p {
                    font-size: $SmallTitleSize;
                    color: #fff;
                }
            }
            .CommList {
                border-radius: 0.07rem;
                border: 1px solid #fff;
                box-sizing: border-box;
                padding: 0.12rem 0.08rem 0.1rem;
                p {
                    font-size: $TextSize;
                    color: #fff;
                    line-height: 0.09rem;
                }
            }
        }
        .ShopDetails{
            width: 90%;
            margin: 0 auto;
            .ShopPic{
                width: 100%;
                img{
                    width: 100%;
                    border-radius: 0.1rem;
                }
            }
        }
        .ShopText{
            width: 90%;
            margin: 0.05rem auto 0;
            p{
                font-size: $TextSize;
                color: #fff;
            }
        }
        .Shop{
            width: 90%;
            margin: 0.1rem auto 0;
            .ButtonWrap{
                p{
                    color: #fff;
                    font-size: $AdditionTextSize;
                }
            }
            .ShopName{
                i{
                    width: 0.3rem;
                    height: 0.3rem;
                    border-radius: 0.05rem;
                    margin-right: 0.05rem;
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 0.05rem;
                    }
                }
                .Text{
                    p:first-child{
                        font-size: $TextSize;
                        font-weight: bold;
                        color: #fff;
                        margin-bottom: 0.05rem;
                        margin-top: 0.02rem;
                    }
                    p:last-child{
                        margin-top: 0.03rem;
                    }
                    p:nth-child(2), p:last-child{
                        font-size: $AdditionTextSize;
                        color: #fff;
                        opacity: 0.6;
                        span{
                            margin-right: 0.02rem;
                        }
                    }
                }
            }
        }
        .LineCut{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
    }
</style>
